import { jsx as _jsx } from "react/jsx-runtime";
import { Error404Image } from "./images/error-404-image";
import { Error500Image } from "./images/error-500-image";
import { ErrorGenericImage } from "./images/error-generic-image";
export function ErrorImage({ errorType = "generic", }) {
    switch (errorType) {
        case "404":
            return _jsx(Error404Image, {});
        case "500":
            return _jsx(Error500Image, {});
        case "generic":
            return _jsx(ErrorGenericImage, {});
        default:
            return _jsx(ErrorGenericImage, {});
    }
}
